import APIAction from "./APIAction"


//defin class
let LanguageAction = {

    getAllUILanguages: async function() {
        let result = await APIAction.request('/anonymous/language/allowed_ui_lang', 'GET', false, null, true, true, 'json', false, true);
        return Array.isArray(result) ? result : [];
    },

    getAllowedDeepLLanguages: async function() {
        let result = await APIAction.request('/anonymous/language/allowed_deepl_lang', 'GET', false, null, true, true, 'json', false, true);
        return Array.isArray(result) ? result : [];
    },

    /**
     * Resolve a language code (e.g. "DE") to its full, preferably native-form name
     * (e.g. "Deutsch"), using an already-fetched list from getAllowedDeepLLanguages().
     *
     * RA source content is always authored in Dutch, but Dutch never appears in the
     * DeepL target-language list (a language can't be a translation target for
     * itself), so it's handled as an explicit special case here.
     *
     * @param {*} languageCode
     * @param {*} allowedDeepLLanguages
     */
    getLanguageDisplayName: function(languageCode, allowedDeepLLanguages = []) {
        if (!languageCode) return '';

        let code = languageCode.toUpperCase();

        if (code === 'NL') return 'Nederlands';

        let match = (allowedDeepLLanguages || []).find((l) => l.languageCode && l.languageCode.toUpperCase() === code);

        //fall back to the raw code if unmatched (e.g. list not loaded yet) rather than showing nothing
        return match ? (match.nativeName || match.name) : languageCode;
    }
}


export default LanguageAction;